export default class ObjectId {
  private static counter = Math.floor(Math.random() * 0xffffff);
  private id: string;

  constructor() {
    this.id = ObjectId.generate();
  }

  toString(): string {
    return this.id;
  }

  toHexString(): string {
    return this.id;
  }

  static generate(): string {
    const timestamp = Math.floor(Date.now() / 1000);
    const timestampHex = timestamp.toString(16).padStart(8, "0");

    const randomBytes = crypto.getRandomValues(new Uint8Array(5));
    const randomHex = Array.from(randomBytes)
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");

    ObjectId.counter = (ObjectId.counter + 1) % 0xffffff;
    const counterHex = ObjectId.counter.toString(16).padStart(6, "0");

    return timestampHex + randomHex + counterHex;
  }

  static create(): ObjectId {
    return new ObjectId();
  }
}
